// src/features/plan/directivesClient.js
//
// PLAN-STRATEGY-BAND-S1: Thin fetch wrappers for /api/plan/directives.

const BASE = "/api/plan/directives";

async function fetchJson(url, options = {}) {
  const res = await fetch(url, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw Object.assign(new Error(body.error ?? `HTTP ${res.status}`), { status: res.status, body });
  }
  return res.json();
}

export function getDirectives() {
  return fetchJson(BASE);
}

export function createDirective(payload) {
  return fetchJson(BASE, {
    method:  "POST",
    body:    JSON.stringify(payload),
  });
}

export function updateDirective(id, payload) {
  return fetchJson(`${BASE}/${id}`, {
    method:  "PATCH",
    body:    JSON.stringify(payload),
  });
}

export function deleteDirective(id) {
  return fetchJson(`${BASE}/${id}`, {
    method: "DELETE",
  });
}
